<template>
  <nav class="panel">
    <p class="panel-heading">
      Address
    </p>
    <div class="panel-block is-active">
      <div class="field-body">
        <div class="field">
          <div class="control">
            <label class="label is-small">Street</label>
            <input class="input is-small is-rounded" type="text" placeholder="Street" v-model="value.street">
          </div>
        </div>
      </div>
    </div>
    <div class="panel-block is-active">
      <div class="field-body">
        <div class="field">
          <div class="control">
            <label class="label is-small">City</label>
            <input class="input is-small is-rounded" type="text" placeholder="City" v-model="value.city">
          </div>
        </div>
      </div>
    </div>
    <div class="panel-block is-active">
      <div class="field-body">
        <div class="field">
          <div class="control">
            <label class="label is-small">Country</label>
            <input class="input is-small is-rounded" type="text" placeholder="Country" v-model="value.country">
          </div>
        </div>
      </div>
    </div>
    <div class="panel-block is-active">
      <div class="field-body">
        <div class="field">
          <div class="control">
            <label class="label is-small">postcode</label>
            <input class="input is-small is-rounded" type="text" placeholder="Postcode" v-model="value.postcode">
          </div>
        </div>
      </div>
    </div>
    <div class="panel-block is-active">
      <div class="level">
        <div class="level-item">
          <div class="field-body">
            <div class="field">
              <div class="control">
                <label class="label is-small">Latitude</label>
                <input class="input is-small is-rounded" type="text" placeholder="Latitude" v-model="value.position.lat">
              </div>
            </div>
          </div>
        </div>
        <div class="level-item">
          <div class="field-body">
            <div class="field">
              <div class="control">
                <label class="label is-small">Longitude</label>
                <input class="input is-small is-rounded" type="text" placeholder="Longitude" v-model="value.position.lng">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
      default () {
        return {
          street: '',
          city: '',
          country: '',
          postcode: '',
          position: {
            lat: 36.0621479,
            lng: 14.2006471
          }
        }
      }
    }
  },
  methods: {
    updateInput (value) {
      this.$emit('input', value)
    }
  },
  watch: {
    value: {
      handler (newval) {
        this.updateInput(newval)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/AddressEditPanel.vue